import { DocumentFillingStatus, ISelfDeclaration } from '@/models/documents.model';

const getLocalSelfDeclarationStatus = (selfDeclaration?: ISelfDeclaration | null) => {
  const expired = new Date(selfDeclaration?.expires_at ?? '') < new Date();

  switch (true) {
    case expired:
      return DocumentFillingStatus.EXPIRED;
    case !!selfDeclaration?.file_link && !expired:
      return DocumentFillingStatus.FILLED;
    case !selfDeclaration?.file_link:
    default:
      return DocumentFillingStatus.UNFILLED;
  }
};

export default getLocalSelfDeclarationStatus;
